import React, { useState } from "react";
import { Input, InputNumber, Modal } from "antd";
function RefundModal({ refunding, saving, onSave, onCancel }) {
  const [reason, setReason] = useState("");
  const [refundAmount, setRefundAmount] = useState(refunding.cash_paise / 100);
  return (
    <Modal
      title="Refund wallet ride"
      open={!!refunding}
      confirmLoading={saving}
      onCancel={() => !saving && onCancel()}
      onOk={() =>
        onSave({ cash_paise: Math.round(refundAmount * 100), reason })
      }
      okButtonProps={{
        disabled: reason.trim().length < 5,
      }}
    >
      <p>
        Enter the cumulative cash refund in INR, including any prior refund. The
        server restores the proportional promotional credit separately. This
        operation also reverses rewards earned from this ride.
      </p>
      <InputNumber
        min={(refunding?.result?.refunded_cash_paise || 0) / 100}
        max={(refunding?.cash_paise || 0) / 100}
        precision={2}
        value={refundAmount}
        onChange={setRefundAmount}
      />
      <Input.TextArea
        style={{
          marginTop: 16,
        }}
        value={reason}
        maxLength={180}
        onChange={(e) => setReason(e.target.value)}
        placeholder="Refund reason"
      />
    </Modal>
  );
}
export default RefundModal;
